import axios from 'axios';

import { IInterviewerEvaluate } from '../types/IInterviewerEvaluate';
import { IInterviewerEvaluateName } from '../types/IInterviewerEvaluateName';
import { IInviteCandidateInfoReq } from '../types/IInviteCandidateInfoReq';
import { IInviteGuestUser } from '../types/IInviteGuestUser';
import { IInviteGuestUserByInformation } from '../types/IInviteGuestUserByInformation';
import { IShareEvaluationResponse } from '../types/IShareEvaluationResponse';
import { IShareInfoReqResponse } from '../types/IShareInfoReqResponse';

const url = '/wisestepexternal/api/authenticate';

export const sendGuestLoginOtp = (email: string) => axios.get(`${url}/guest/${email}`);

export const validateGuestOtp = (otp: string, email: string) =>
  axios.post(`${url}/otp/${otp}/${email}`);

export const getGuestOtpExpiryTime = (email: string) =>
  axios.get(`${url}/otp-expiry-time/${email}`);

export const inviteShareCandidateUsers = (payload: IInviteGuestUser) =>
  axios.post('/wisestepexternal/api/invite/guest/users', payload);

export const validateGuestLink = (id: string) =>
  axios.get(`/wisestepexternal/api/validate/link/${id}`);

export const markGuestUserEvaluation = (
  id: string,
  email: string,
  feedbackGivenBy: string,
  feedbackGivenByName: string
) =>
  axios.post(`/wisestepexternal/api/link/evaluated`, {
    inviteId: id,
    email: email,
    feedbackGivenBy: feedbackGivenBy,
    feedbackGivenByName: feedbackGivenByName,
  });

export const shareResponseToGuest = (payload: IShareEvaluationResponse) =>
  axios.post(`/wisestepexternal/api/share/response/to/guest`, payload);

export const postEvaluationTemplateList = (payload: IInterviewerEvaluate) =>
  axios.post('/wisestepexternal/api/eval/template/list', payload);

export const postReshareForEvaluation = (payload: IInterviewerEvaluate) =>
  axios.post('/wisestepexternal/api/reshare/for/evaluation', payload);

export const getGuestUserDetails = () => axios.get('wisestepexternal/api/get-user');

export const postEvaluatedLink = (payload: IInterviewerEvaluateName) =>
  axios.post('wisestepexternal/api/link/evaluated', payload);

export const getInvitedUsers = (inviteId: string) =>
  axios.get(`/wisestepexternal/api/get/users-by-invite-id/${inviteId}`);

export const inviteCandidateInformationReq = (payload: IInviteCandidateInfoReq) =>
  axios.post('/wisestepexternal/api/invite/candidate-info-req', payload);

export const validateInfoReqLink = (id: string) =>
  axios.get(`/wisestepexternal/api/validate/info-req/${id}`);

export const shareInfoReqResponseWithCandidate = (payload: IShareInfoReqResponse) =>
  axios.post(`/wisestepexternal/api/share-info-req-response`, payload);

export const inviteShareCandidateUsersByInformation = (payload: IInviteGuestUserByInformation) =>
  axios.post('/wisestepexternal/api/invite/candidate-info-req', payload);

export const getCandidateIp = () => axios.get('/wisestepexternal/api/getcandidateip');

export const markInviteLinkExpired = (informationReqResponseId: string) =>
  axios.get(`/wisestepexternal/api/expire/link/info-req/${informationReqResponseId}`);
